import { render, staticRenderFns } from "./geocercasGrupoDetalle.vue?vue&type=template&id=178d0093"
import script from "./geocercasGrupoDetalle.vue?vue&type=script&lang=js"
export * from "./geocercasGrupoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports